import React from "react";
import { Alert, Button } from "@mui/material";

/** Error message for a list that failed to load (design item 17) — never the empty-state text. */
export default function LoadError({ what = "this list", error, onRetry, sx }) {
  const status = error?.response?.status;
  return (
    <Alert
      severity="error"
      sx={{ my: 2, alignItems: "center", ...sx }}
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry} sx={{ fontWeight: 600 }}>
            Retry
          </Button>
        ) : null
      }
    >
      <strong>Couldn’t load {what}.</strong>{" "}
      {status ? `The server answered with error ${status}. ` : "The server didn’t answer. "}
      Nothing has been changed.
    </Alert>
  );
}

/** Pull a request error out of a caught value for LoadError. */
export const asLoadError = (err) => err || { response: undefined };
